module.exports = __webpack_public_path__ + "img/symbol_0.d08d54c5.png";